<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <b-table :busy="isBusy" :fields="fields" :items="filteredItems" sticky-header responsive no-border-collapse
            select-mode="single" selectable @row-selected="onRowSelected" show-empty>

            <template #empty>
                <b-card v-if="items.length !== 0" class="text-center my-2 fs-5">
                    No hay correos sin visualizar que coincidan con los criterios de búsqueda
                </b-card>
                <b-card v-else class="text-center my-2 fs-5">
                    Todos los destinatarios han visto el documento
                </b-card>
            </template>

            <!--icono de carga de tabla-->
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando datos de tabla...</strong>
                </div>
            </template>

        </b-table>
    </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { mapActions } from 'vuex';

export default {
    name: 'DocumentNonVisitorTable',

    components: {
        AlertDismiss
    },

    data() {
        return {
            isBusy: false,
            items: [],
            selected: [],

            fields: [
                { key: 'correo', label: 'Usuarios por visitar el documento' }
            ]
        }
    },

    props: {
        documentId: {
            type: String
        }
    },

    async mounted() {
        await this.getAllNonVisitor();
    },

    computed: {
        filteredItems() {
            let filtered = this.items;

            // Filtrar aqui

            return filtered;
        }
    },

    methods: {
        ...mapActions(["getAllNonVisitorForDocumentId"]),

        onRowSelected(items) {
            this.selected = items;
        },

        processingTable() {
            this.isBusy = !this.isBusy
        },

        async getAllNonVisitor() {
            this.processingTable();
            let result = await this.getAllNonVisitorForDocumentId({ documentId: this.documentId });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.processingTable();
                return;
            }

            // Map the result to the expected format
            this.items = result.data.map(visitor => ({correo: visitor.visitorMail}));
            this.processingTable();
        }
    }

}
</script>
<style></style>